var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('detail-view',{attrs:{"config":_vm.config},on:{"save":_vm.save}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }